import { Directive } from '@angular/core';

@Directive({
    selector: '[zappPermissionsExcept]',
    standalone: true,
})
export class PermissionsExceptDirective {

  constructor() { }

}
